// extracted by mini-css-extract-plugin
export default {"navigation_bar":"Navigation_navigation_bar__mLDmd","logo":"Navigation_logo__O3Xwu","nav_links":"Navigation_nav_links__NLLWQ","social_links":"Navigation_social_links__Hl9pY"};